import {createMuiltLanguagesJson} from "@/components/widgets/nav/repeatNumber.js";

export const contactActions = ['contactTop', 'design', 'hover', 'isShow']
export default {
  name: '容器',
  componentName: 'divContainer',
  disabled: false,
  cusClass: 'wHeadPcSix',
  data: {
    attribute: {
      self_text: ''
    },
    design: {
      self_paddingTop: {
        diannao: 0,
        pingban: 0,
        shouji: 0
      },
      self_paddingBottom: {
        diannao: 0,
        pingban: 0,
        shouji: 0
      },
      self_paddingLeft: {
        diannao: 0,
        pingban: 0,
        shouji: 0
      },
      self_paddingRight: {
        diannao: 0,
        pingban: 0,
        shouji: 0
      },
      self_paddingUnit: {
        diannao: 'px',
        pingban: 'px',
        shouji: 'px'
      },
      self_marginTop: {
        diannao: 0,
        pingban: 0,
        shouji: 0
      },
      self_marginBottom: {
        diannao: 0,
        pingban: 0,
        shouji: 0
      },
      self_marginUnit: {
        diannao: 'px',
        pingban: 'px',
        shouji: 'px'
      }
    }
  },
  list: [
    {
      name: '容器',
      componentName: 'card',
      cusClass:'fixBackgroundColor',
      disabled: false,
      actions: [
        {
          name: 'design',
          config: {
            设置: ['3', 'self_borderRadius']
          }
        }
      ],
      data: {
        attribute: {
          self_text: ''
        },
        design: {
          self_paddingTop: {
            diannao: 0,
            pingban: 0,
            shouji: 0
          },
          self_paddingBottom: {
            diannao: 0,
            pingban: 0,
            shouji: 0
          },
          self_paddingLeft: {
            diannao: 0,
            pingban: 0,
            shouji: 0
          },
          self_paddingRight: {
            diannao: 0,
            pingban: 0,
            shouji: 0
          },
          self_paddingUnit: {
            diannao: 'px',
            pingban: 'px',
            shouji: 'px'
          },
          self_marginTop: {
            diannao: 0,
            pingban: 0,
            shouji: 0
          },
          self_marginBottom: {
            diannao: 0,
            pingban: 0,
            shouji: 0
          },
          self_marginUnit: {
            diannao: 'px',
            pingban: 'px',
            shouji: 'px'
          },
          self_backgroundColor: {
            diannao: '#251619',
            pingban: '#251619',
            shouji: '#251619'
          }
        }
      },
      list: [
        {
          name: '一行一列',
          componentName: 'rowCol',
          disabled: true,
          data: {
            design: {
              self_marginTop: {
                diannao: 0,
                pingban: 0,
                shouji: 0
              },
              self_marginBottom: {
                diannao: 0,
                pingban: 0,
                shouji: 0
              },
              self_marginUnit: {
                diannao: 'px',
                pingban: 'px',
                shouji: 'px'
              }
            }
          },
          list: [
            {
              name: '列',
              componentName: 'col',
              _width: 100,
              data: {
                design: {
                  self_marginTop: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  self_marginBottom: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  self_marginUnit: {
                    diannao: 'px',
                    pingban: 'px',
                    shouji: 'px'
                  },
                  self_paddingTop: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  self_paddingBottom: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  self_paddingLeft: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  self_paddingRight: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  self_paddingUnit: {
                    diannao: 'px',
                    pingban: 'px',
                    shouji: 'px'
                  }
                }
              },
              list: [
                {
                  name: '卡片',
                  componentName: 'divContainer',
                  data: {
                    attribute: {
                      self_text: 'display:flex;align-items:center;justify-content:space-between;'
                    },
                    design: {
                      self_marginTop: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginBottom: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginLeft: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginRight: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginUnit: {
                        diannao: 'px',
                        pingban: 'px',
                        shouji: 'px'
                      },
                      self_paddingTop: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_paddingBottom: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_paddingLeft: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_paddingRight: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_paddingUnit: {
                        diannao: 'px',
                        pingban: 'px',
                        shouji: 'px'
                      },
                      self_borderBottomWidth: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_borderTopWidth: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_borderLeftWidth: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_borderRightWidth: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      }
                    }
                  },
                  list: [
                    {
                      name: '卡片',
                      componentName: 'divContainer',
                      data: {
                        attribute: {
                          self_text: 'display:flex;align-items:center;'
                        },
                        design: {
                          self_marginTop: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_marginBottom: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_marginLeft: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_marginRight: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_marginUnit: {
                            diannao: 'px',
                            pingban: 'px',
                            shouji: 'px'
                          },
                          self_paddingTop: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_paddingBottom: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_paddingLeft: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_paddingRight: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_paddingUnit: {
                            diannao: 'px',
                            pingban: 'px',
                            shouji: 'px'
                          },
                          self_borderBottomWidth: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_borderTopWidth: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_borderLeftWidth: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_borderRightWidth: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          }
                        }
                      },
                      list: [
                        {
                          name: '顶部联系方式',
                          componentName: 'contact_top',
                          _type: 'contact_top',
                          _icon: '',
                          _textColor: '#333',
                          _iconColor: '#fff',
                          _textHoverColor: '#333',
                          actions: contactActions,
                          _contentType: 1,
                          flag: 'contact_top_1',
                          data: {
                            design: {
                              self_lineHeight: {
                                diannao: 36,
                                pingban: 36,
                                shouji: 36
                              },
                              self_color: {
                                diannao: '#fff',
                                pingban: '#fff',
                                shouji: '#fff'
                              },
                              self_marginRight: {
                                diannao: 10,
                                pingban: 10,
                                shouji: 10
                              },
                              self_marginUnit: {
                                diannao: 'px',
                                pingban: 'px',
                                shouji: 'px'
                              },
                              self_fontSize: {
                                diannao: 12,
                                pingban: 12,
                                shouji: 12
                              },
                              self_fontSizeUnit: {
                                diannao: 'px',
                                pingban: 'px',
                                shouji: 'px'
                              },
                              languageSwtichTitleText_fontSize: {
                                diannao: 12,
                                pingban: 12,
                                shouji: 12
                              },
                              languageSwtichTitleText_fontSizeUnit: {
                                diannao: 'px',
                                pingban: 'px',
                                shouji: 'px'
                              },
                              self_width: {
                                diannao: 'auto',
                                pingban: 'auto',
                                shouji: 'auto'
                              },
                              self_widthUnit: {
                                diannao: '',
                                pingban: '',
                                shouji: ''
                              },
                              icon_color: {
                                diannao: '#fff',
                                pingban: '#fff',
                                shouji: '#fff'
                              },
                              self_fontWeight: {
                                diannao: 'bold',
                                pingban: 'bold',
                                shouji: 'bold'
                              }
                            },
                            hover: {
                              self_hoverFontWeight: {
                                diannao: 'bold',
                                pingban: 'bold',
                                shouji: 'bold'
                              },
                              self_hoverColor: {
                                diannao: '#fff',
                                pingban: '#fff',
                                shouji: '#fff'
                              },
                              self_hoverFontSize: {
                                diannao: 12,
                                pingban: 12,
                                shouji: 12
                              },
                              self_hoverFontSizeUnit: {
                                diannao: 'px',
                                pingban: 'px',
                                shouji: 'px'
                              },
                              languageSwtichTitleText_hoverFontSize: {
                                diannao: 12,
                                pingban: 12,
                                shouji: 12
                              },
                              languageSwtichTitleText_hoverFontSizeUnit: {
                                diannao: 'px',
                                pingban: 'px',
                                shouji: 'px'
                              }
                            }
                          }
                        },
                        {
                          name: '顶部联系方式',
                          componentName: 'contact_top',
                          _type: 'contact_top',
                          _icon: '',
                          _textColor: '#fff',
                          _textHoverColor: '#fff',
                          actions: contactActions,
                          _contentType: 3,
                          flag: 'contact_top_2',
                          data: {
                            design: {
                              self_lineHeight: {
                                diannao: 36,
                                pingban: 36,
                                shouji: 36
                              },
                              self_color: {
                                diannao: '#fff',
                                pingban: '#fff',
                                shouji: '#fff'
                              },
                              self_fontSize: {
                                diannao: 12,
                                pingban: 12,
                                shouji: 12
                              },
                              self_fontSizeUnit: {
                                diannao: 'px',
                                pingban: 'px',
                                shouji: 'px'
                              },
                              self_width: {
                                diannao: 'auto',
                                pingban: 'auto',
                                shouji: 'auto'
                              },
                              self_widthUnit: {
                                diannao: '',
                                pingban: '',
                                shouji: ''
                              },
                              icon_color: {
                                diannao: '#fff',
                                pingban: '#fff',
                                shouji: '#fff'
                              },
                              self_fontWeight: {
                                diannao: 'bold',
                                pingban: 'bold',
                                shouji: 'bold'
                              }
                            },
                            hover: {
                              self_hoverColor: {
                                diannao: '#fff',
                                pingban: '#fff',
                                shouji: '#fff'
                              },
                              self_hoverFontSize: {
                                diannao: 12,
                                pingban: 12,
                                shouji: 12
                              },
                              self_hoverFontSizeUnit: {
                                diannao: 'px',
                                pingban: 'px',
                                shouji: 'px'
                              },
                              self_hoverFontWeight: {
                                diannao: 'bold',
                                pingban: 'bold',
                                shouji: 'bold'
                              }
                            }
                          }
                        }
                      ]
                    },
                    {
                      name: '卡片',
                      componentName: 'divContainer',
                      data: {
                        attribute: {
                          self_text: 'display:flex;align-items:center;'
                        },
                        design: {
                          self_marginTop: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_marginBottom: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_marginLeft: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_marginRight: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_marginUnit: {
                            diannao: 'px',
                            pingban: 'px',
                            shouji: 'px'
                          },
                          self_paddingTop: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_paddingBottom: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_paddingLeft: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_paddingRight: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_paddingUnit: {
                            diannao: 'px',
                            pingban: 'px',
                            shouji: 'px'
                          },
                          self_borderBottomWidth: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_borderTopWidth: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_borderLeftWidth: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          },
                          self_borderRightWidth: {
                            diannao: 0,
                            pingban: 0,
                            shouji: 0
                          }
                        }
                      },
                      list: [
                        {
                          name: '国旗与国家名称-下拉-直角',
                          componentName: 'language_flagNameSelect',
                          _type: 'rect',
                          actions: ['attribute', 'design', 'hover'],
                          cusClass: 'add-pointer-style',
                          data: {
                            design: {
                              boxHeight_borderBottomColor: {
                                diannao: '',
                                pingban: '',
                                shouji: ''
                              },
                              boxHeight_borderTopColor: {
                                diannao: '',
                                pingban: '',
                                shouji: ''
                              },
                              boxHeight_borderLeftColor: {
                                diannao: '',
                                pingban: '',
                                shouji: ''
                              },
                              boxHeight_borderRightColor: {
                                diannao: '',
                                pingban: '',
                                shouji: ''
                              },
                              boxHeight_borderBottomWidth: {
                                diannao: 0,
                                pingban: 0,
                                shouji: 0
                              },
                              boxHeight_borderTopWidth: {
                                diannao: 0,
                                pingban: 0,
                                shouji: 0
                              },
                              boxHeight_borderLeftWidth: {
                                diannao: 0,
                                pingban: 0,
                                shouji: 0
                              },
                              boxHeight_borderRightWidth: {
                                diannao: 0,
                                pingban: 0,
                                shouji: 0
                              },
                              self_width: {
                                diannao: 150,
                                pingban: 150,
                                shouji: 150
                              },
                              self_widthUnit: {
                                diannao: 'px',
                                pingban: 'px',
                                shouji: 'px'
                              },
                              self_marginTop: {
                                diannao: 0,
                                pingban: 0,
                                shouji: 0
                              },
                              self_marginBottom: {
                                diannao: 0,
                                pingban: 0,
                                shouji: 0
                              },
                              self_marginUnit: {
                                diannao: 'px',
                                pingban: 'px',
                                shouji: 'px'
                              },
                              self_fontSize: {
                                diannao: 12,
                                pingban: 12,
                                shouji: 12
                              },
                              self_fontSizeUnit: {
                                diannao: 'px',
                                pingban: 'px',
                                shouji: 'px'
                              },
                              boxHeight_height: {
                                diannao: 36,
                                pingban: 36,
                                shouji: 36
                              },
                              languageSwtichTitleText_color: {
                                diannao: '#fff',
                                pingban: '#fff',
                                shouji: '#fff'
                              },
                              iconColor_color: {
                                diannao: '#fff',
                                pingban: '#fff',
                                shouji: '#fff'
                              },
                              languageSwtichTitleText_fontSize: {
                                diannao: 12,
                                pingban: 12,
                                shouji: 12
                              },
                              languageSwtichTitleText_fontSizeUnit: {
                                diannao: 'px',
                                pingban: 'px',
                                shouji: 'px'
                              }
                            },
                            hover: {
                              languageSwtichTitleText_hoverColor: {
                                diannao: '#333',
                                pingban: '#333',
                                shouji: '#333'
                              },
                              languageSwtichTitleText_hoverFontSize: {
                                diannao: 12,
                                pingban: 12,
                                shouji: 12
                              },
                              languageSwtichTitleText_hoverFontSizeUnit: {
                                diannao: 'px',
                                pingban: 'px',
                                shouji: 'px'
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: '容器',
      componentName: 'card',
      disabled: false,
      cusClass:'fixBackgroundColor',
      actions: [
        {
          name: 'design',
          config: {
            设置: ['3', 'self_borderRadius']
          }
        }
      ],
      data: {
        attribute: {
          self_text: 'display:flex;align-items:center;justify-content:center;'
        },
        design: {
          self_paddingTop: {
            diannao: 0,
            pingban: 0,
            shouji: 0
          },
          self_paddingBottom: {
            diannao: 0,
            pingban: 0,
            shouji: 0
          },
          self_paddingLeft: {
            diannao: 0,
            pingban: 0,
            shouji: 0
          },
          self_paddingRight: {
            diannao: 0,
            pingban: 0,
            shouji: 0
          },
          self_paddingUnit: {
            diannao: 'px',
            pingban: 'px',
            shouji: 'px'
          },
          self_marginTop: {
            diannao: 0,
            pingban: 0,
            shouji: 0
          },
          self_marginBottom: {
            diannao: 0,
            pingban: 0,
            shouji: 0
          },
          self_marginUnit: {
            diannao: 'px',
            pingban: 'px',
            shouji: 'px'
          },
          self_backgroundColor: {
            diannao: 'var(--dominantColor)',
            pingban: 'var(--dominantColor)',
            shouji: 'var(--dominantColor)'
          }
        }
      },
      list: [
        {
          name: '容器',
          componentName: 'div',
          class: 'leftDiv',
          cusClass:'fixDelBackgroundColor',
        },
        {
          name: '一行一列',
          componentName: 'rowCol',
          disabled: true,
          data: {
            design: {
              self_marginTop: {
                diannao: 0,
                pingban: 0,
                shouji: 0
              },
              self_marginBottom: {
                diannao: 0,
                pingban: 0,
                shouji: 0
              },
              self_marginUnit: {
                diannao: 'px',
                pingban: 'px',
                shouji: 'px'
              }
            }
          },
          list: [
            {
              name: 'logo',
              componentName: 'image_image1',
              _type: 'image',
              flag: 'pc-logo',
              actions: [
                'attribute',
                {
                  name: 'design',
                  config: {
                    分组: ['self_borderRadius', 'self_background']
                  }
                },
                'link',
                'translate',
                'isShow'
              ],
              cusClass: 'sixLogo fixDelBackgroundColor',
              disabled: false,
              isHideMargin: true,
              imgBoxStyle: { 'object-fit': 'contain', 'aspect-ratio': 200 / 70 },
              imgStyle: { 'object-fit': 'contain', 'aspect-ratio': 200 / 70 },
              data: {
                attribute: {
                  img_url:
                    '//images-oss-demo.chukouplus.com/upload/C_1/file/20251110/02c671050e89a786f60b32c11a577b44.png'
                },
                design: {
                  self_backgroundColor: {
                    diannao: '#fff',
                    pingban: '#fff',
                    shouji: '#fff'
                  },
                  img_width: {
                    diannao: 100,
                    pingban: 'auto',
                    shouji: 'auto'
                  },
                  img_widthUnit: {
                    diannao: '%',
                    pingban: '',
                    shouji: ''
                  },
                  img_height: {
                    diannao: '100',
                    pingban: '100',
                    shouji: '100'
                  },
                  img_heightUnit: {
                    diannao: '%',
                    pingban: '%',
                    shouji: '%'
                  },
                  self_height: {
                    diannao: 70,
                    pingban: 70,
                    shouji: 70
                  },
                  self_heightUnit: {
                    diannao: 'px',
                    pingban: 'px',
                    shouji: 'px'
                  },
                  self_marginTop: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  self_marginBottom: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  self_marginUnit: {
                    diannao: 'px',
                    pingban: 'px',
                    shouji: 'px'
                  },
                  self_width: {
                    diannao: 200,
                    pingban: 200,
                    shouji: 200
                  },
                  self_widthUnit: {
                    diannao: 'px',
                    pingban: 'px',
                    shouji: 'px'
                  }
                },
                link: {
                  blank: false,
                  type: "inWebSite",
                  url: "/",
                  weight: false
                }
              }
            },
            {
              name: '容器',
              componentName: 'div',
              class: 'triangleDiv',
              cusClass:'fixDelBackgroundColor',
            },
            {
              name: '顶部导航',
              componentName: 'nav',
              _type: 'nav_top_style1',
              flag: 'headNav',
              actions: ['attribute', 'design', 'hover'],
              _isHideFirstLineHeight: true,
              data: {
                attribute: {
                  repeatNumber_value: createMuiltLanguagesJson(8),
                  isCollapse_radioValue: true
                },
                design: {
                  elementFirstNavItem_marginTop: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  elementFirstNavItem_marginBottom: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  elementFirstNavItem_paddingTop: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  elementOtherNav_backgroundColor: {
                    diannao: 'var(--dominantColor)',
                    pingban: 'var(--dominantColor)',
                    shouji: 'var(--dominantColor)'
                  },
                  self_backgroundColor: {
                    diannao: '',
                    pingban: '',
                    shouji: ''
                  },
                  elementFirstNavItem_lineHeight: {
                    diannao: 70,
                    pingban: 70,
                    shouji: 70
                  },
                  elementFirstNavItem_height: {
                    diannao: 70,
                    pingban: 70,
                    shouji: 70
                  },
                  elementFirstNavItem_heightUnit: {
                    diannao: 'px',
                    pingban: 'px',
                    shouji: 'px'
                  },
                  elementOtherNavItem_width: {
                    diannao: 330,
                    pingban: 330,
                    shouji: 330
                  },
                  elementOtherNavItem_widthUnit: {
                    diannao: 'px',
                    pingban: 'px',
                    shouji: 'px'
                  },
                  elementOtherNavItem_paddingLeft: {
                    diannao: 20,
                    pingban: 20,
                    shouji: 10
                  },
                  elementOtherNavItem_paddingRight: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  elementOtherNavItem_paddingBottom: {
                    diannao: 10,
                    pingban: 10,
                    shouji: 10
                  },
                  elementFirstNavItem_color: {
                    diannao: '#FFFFFF',
                    pingban: '#FFFFFF',
                    shouji: '#FFFFFF'
                  },
                  elementOtherNavItem_color: {
                    diannao: '#fff',
                    pingban: '#fff',
                    shouji: '#fff'
                  },
                  elementOtherNavItem_backgroundColor: {
                    diannao: '#fff',
                    pingban: '#fff',
                    shouji: '#fff'
                  },
                  elementFirstNavItem_fontSize: {
                    diannao: 13,
                    pingban: 13,
                    shouji: 13
                  },
                  elementOtherNavItem_fontSize: {
                    diannao: 13,
                    pingban: 13,
                    shouji: 13
                  },
                  elementFirstNavItem_paddingLeft: {
                    diannao: 20,
                    pingban: 20,
                    shouji: 0
                  },
                  elementFirstNavItem_paddingRight: {
                    diannao: 20,
                    pingban: 20,
                    shouji: 0
                  },
                  elementFirstNavItem_paddingBottom: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  elementFirstNavItem_paddingUnit: {
                    diannao: 'px',
                    pingban: 'px',
                    shouji: 'px'
                  },
                  elementFirstNavItem_marginLeft: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  elementFirstNavItem_marginRight: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  elementFirstNavItem_marginUnit: {
                    diannao: 'px',
                    pingban: 'px',
                    shouji: 'px'
                  },
                  elementOtherNav_borderTopColor: {
                    diannao: '',
                    pingban: '',
                    shouji: ''
                  },
                  elementOtherNav_borderTopWidth: {
                    diannao: '',
                    pingban: '',
                    shouji: ''
                  },
                  elementOtherNavItem_borderRadiusLeftTop: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  self_width: {
                    diannao: 'auto',
                    pingban: 'auto',
                    shouji: 'auto'
                  },
                  self_widthUnit: {
                    diannao: '',
                    pingban: '',
                    shouji: ''
                  }
                },
                hover: {
                  elementFirstNavItem_hoverBackgroundColor: {
                    diannao: 'var(--dominantColor)',
                    pingban: 'var(--dominantColor)',
                    shouji: 'var(--dominantColor)'
                  },
                  elementFirstNavItem_hoverFontSize: {
                    diannao: 13,
                    pingban: 13,
                    shouji: 13
                  },
                  elementFirstNavItem_hoverColor: {
                    diannao: '#FFFFFF',
                    pingban: '#FFFFFF',
                    shouji: '#FFFFFF'
                  },
                  elementOtherNavItem_hoverFontSize: {
                    diannao: 13,
                    pingban: 13,
                    shouji: 13
                  },
                  elementOtherNavItem_hoverColor: {
                    diannao: '#fff',
                    pingban: '#fff',
                    shouji: '#fff'
                  },
                  elementOtherNavItem_hoverBackgroundColor: {
                    diannao: 'var(--dominantColor)',
                    pingban: 'var(--dominantColor)',
                    shouji: 'var(--dominantColor)'
                  },
                  elementOtherNav_hoverBorderTopColor: {
                    diannao: '',
                    pingban: '',
                    shouji: ''
                  },
                  elementOtherNav_hoverBorderTopWidth: {
                    diannao: '',
                    pingban: '',
                    shouji: ''
                  },
                  elementOtherNav_hoverBackgroundColor: {
                    diannao: '#111',
                    pingban: '#111',
                    shouji: '#111'
                  },
                  elementOtherNavItem_hoverBorderRadiusLeftTop: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  }
                }
              }
            },
            {
              name: '搜索',
              componentName: 'search',
              _type: 'search1',
              class: 'search1',
              actions: ['design', 'hover'],
              isHideMargin: true,
              isHidePadding: true,
              data: {
                design: {
                  self_width: {
                    diannao: 200,
                    pingban: 200,
                    shouji: 200
                  },
                  self_widthUnit: {
                    diannao: 'px',
                    pingban: 'px',
                    shouji: 'px'
                  },
                  self_height: {
                    diannao: 30,
                    pingban: 30,
                    shouji: 30
                  },
                  self_heightUnit: {
                    diannao: 'px',
                    pingban: 'px',
                    shouji: 'px'
                  },
                  self_marginTop: {
                    diannao: 20,
                    pingban: 20,
                    shouji: 20
                  },
                  self_marginLeft: {
                    diannao: 15,
                    pingban: 15,
                    shouji: 0
                  },
                  self_marginBottom: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  self_marginUnit: {
                    diannao: 'px',
                    pingban: 'px',
                    shouji: 'px'
                  },
                  self_borderTopColor: {
                    diannao: '#fff',
                    pingban: '#fff',
                    shouji: '#fff'
                  },
                  self_borderTopWidth: {
                    diannao: 1,
                    pingban: 1,
                    shouji: 1
                  },
                  self_borderRightColor: {
                    diannao: '#fff',
                    pingban: '#fff',
                    shouji: '#fff'
                  },
                  self_borderRightWidth: {
                    diannao: 1,
                    pingban: 1,
                    shouji: 1
                  },
                  self_borderBottomColor: {
                    diannao: '#fff',
                    pingban: '#fff',
                    shouji: '#fff'
                  },
                  self_borderBottomWidth: {
                    diannao: 1,
                    pingban: 1,
                    shouji: 1
                  },
                  self_borderLeftColor: {
                    diannao: '#fff',
                    pingban: '#fff',
                    shouji: '#fff'
                  },
                  self_borderLeftWidth: {
                    diannao: 1,
                    pingban: 1,
                    shouji: 1
                  },
                  self_borderRadiusLeftTop: {
                    diannao: 10,
                    pingban: 10,
                    shouji: 10
                  },
                  self_borderRadiusRightTop: {
                    diannao: 10,
                    pingban: 10,
                    shouji: 10
                  },
                  self_borderRadiusRightBottom: {
                    diannao: 10,
                    pingban: 10,
                    shouji: 10
                  },
                  self_borderRadiusLeftBottom: {
                    diannao: 10,
                    pingban: 10,
                    shouji: 10
                  },
                  self_paddingLeft: {
                    diannao: 10,
                    pingban: 10,
                    shouji: 10
                  },
                  self_paddingUnit: {
                    diannao: 'px',
                    pingban: 'px',
                    shouji: 'px'
                  }
                }
              },
              list: [
                {
                  name: '输入框',
                  componentName: 'search_input',
                  select: 'parentNode',
                  actions: ['design', 'hover'],
                  data: {
                    design: {
                      self_marginTop: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginBottom: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_marginLeft: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_marginRight: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_marginUnit: {
                        diannao: 'px',
                        pingban: 'px',
                        shouji: 'px'
                      },
                      self_paddingTop: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_paddingRight: {
                        diannao: 12,
                        pingban: 12,
                        shouji: 12
                      },
                      self_paddingBottom: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_paddingLeft: {
                        diannao: 12,
                        pingban: 12,
                        shouji: 12
                      },
                      self_paddingUnit: {
                        diannao: 'px',
                        pingban: 'px',
                        shouji: 'px'
                      },
                      self_backgroundColor: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_backgroundImage: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_borderTopColor: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_borderRightColor: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_borderBottomColor: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_borderLeftColor: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_borderTopWidth: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_borderRightWidth: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_borderBottomWidth: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_borderLeftWidth: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_borderRadius: {
                        diannao: 6,
                        pingban: 6,
                        shouji: 6
                      }
                    },
                    isShow: true
                  },
                  list: []
                },
                {
                  name: '按钮',
                  componentName: 'button_icon',
                  _backGround: '',
                  _textColor: '#fff',
                  _textHoverColor: '#fff',
                  _borderColor: '',
                  _borderWidth: 1,
                  _borderHoverColor: '',
                  _borderHoverWidth: 1,
                  _icon: '&#xe62e;',
                  cusClass:'fixColor fixDelBackgroundColor',
                  _iconPosition: 'right',
                  disabled: false,
                  actions: [
                    {
                      name: 'design',
                      groupLayout: 'topBottom',
                      config: {
                        分组: [
                          'self_icon',
                          'self_background',
                          'self_width',
                          'self_color',
                          'self_border',
                          'self_borderRadius',
                          'self_shadow'
                        ]
                      }
                    },
                    'hover'
                  ],
                  data: {
                    design: {
                      self_marginBottom: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginTop: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_paddingLeft: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_paddingRight: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_paddingTop: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_paddingBottom: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginUnit: {
                        diannao: 'px',
                        pingban: 'px',
                        shouji: 'px'
                      },
                      self_paddingUnit: {
                        diannao: 'px',
                        pingban: 'px',
                        shouji: 'px'
                      },
                      self_width: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_text: '',
                      self_borderRadiusRightTop: {
                        diannao: 6,
                        pingban: 6,
                        shouji: 6
                      },
                      self_borderRadiusRightTopUnit: {
                        diannao: 'px',
                        pingban: 'px',
                        shouji: 'px'
                      },
                      self_borderRadiusRightBottom: {
                        diannao: 6,
                        pingban: 6,
                        shouji: 6
                      },
                      self_borderRadiusRightBottomUnit: {
                        diannao: 'px',
                        pingban: 'px',
                        shouji: 'px'
                      },
                      self_angleDegrees: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_shadowSpread: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_shadowUnit: {
                        diannao: 'px',
                        pingban: 'px',
                        shouji: 'px'
                      },
                      self_shadowBlur: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_shadowOffset: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_borderTopColor: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_borderRightColor: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_borderBottomColor: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_borderLeftColor: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_borderTopWidth: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_borderRightWidth: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_borderBottomWidth: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_borderLeftWidth: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_icon: '&#xe616;'
                    },
                    hover: {
                      self_hoverBorderTopWidth: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_hoverBorderRightWidth: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_hoverBorderBottomWidth: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_hoverBorderLeftWidth: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_hoverBorderTopColor: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_hoverBorderRightColor: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_hoverBorderBottomColor: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      },
                      self_hoverBorderLeftColor: {
                        diannao: '',
                        pingban: '',
                        shouji: ''
                      }
                    }
                  }
                }
              ]
            }
          ]
        },
        {
          name: '容器',
          componentName: 'div',
          class: 'rightDiv'
        }
      ]
    }
  ]
}
